


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  METHODS,
  STATUSES,
  SERVICE_PAYMENT_STATUSES,
} from '@/constants/payment';
import ServiceOrderCreateOrderReviewTable from './Read/ServiceOrderReadOrderReviewTable.vue';
import QStripeServicePayment from '@/components/QStripeServicePayment.vue';
import ServiceOrderReadOrderReviewTable from './Read/ServiceOrderReadOrderReviewTable.vue';

@Component({
  components: {
    ServiceOrderCreateOrderReviewTable,
    QStripeServicePayment,
    ServiceOrderReadOrderReviewTable,
  },
  computed: {
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
  },
})
export default class ServiceOrderRead extends Vue {
  @Prop({ default: false }) readonly needMarginTop!: boolean;

  isMounted = false;
  retryCount = 0;
  isPaying = false;
  timer: NodeJS.Timeout | null = null;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;
  paymentMethods = METHODS;
  paymentStatuses = SERVICE_PAYMENT_STATUSES;
  paymentTransactionStatuses = STATUSES;

  beforeMount() {
    this.init();
  }

  async init() {
    this.retryCount = 0;
    this.isPaying = true;
    while (this.retryCount < 5) {
      let oid;
      if (this.activeServiceOrder) {
        oid = this.activeServiceOrder.object_id;
      }
      if (this.$route.params.serviceOrderOid) {
        oid = this.$route.params.serviceOrderOid;
      }
      await this.$store.dispatch('ServiceOrder/fetch', oid);

      if (this.activeServicePayment.is_stand_alone) {
        // for normal payment, check the status on activeServicePayment
        if (
          [
            this.paymentStatuses.STATUS_OUTSTANDING.key,
            this.paymentStatuses.STATUS_PAID.key,
            this.paymentStatuses.STATUS_CANCELLED.key,
          ].includes(this.activeServicePayment.status)
        ) {
          break;
        }
        // check the payment transaction on activeServicePayment
        if (!this.activeServicePayment._payment_transaction) {
          break;
        }
        if (
          [
            this.paymentTransactionStatuses.STATUS_SUCCEED.key,
            this.paymentTransactionStatuses.STATUS_FAILED.key,
          ].includes(this.activeServicePayment._payment_transaction.status)
        ) {
          break;
        }
      } else {
        // for installment payment, check the installment status on activeServicePayment (parent)
        if (
          [this.paymentStatuses.STATUS_INSTALLMENT_COMPLETED.key].includes(
            this.activeServicePayment.status
          )
        ) {
          break;
        }
        // check children
        const retryChildren = this.activeServicePayment.children.map(
          (childServicePayment: Model) => {
            // check status of child service payment
            if (
              [
                this.paymentStatuses.STATUS_OUTSTANDING.key,
                this.paymentStatuses.STATUS_PAID.key,
                this.paymentStatuses.STATUS_CANCELLED.key,
              ].includes(childServicePayment.status)
            ) {
              return false;
            }
            // check the payment transaction on child service payment
            if (!childServicePayment._payment_transaction) {
              return false;
            }
            if (
              [
                this.paymentTransactionStatuses.STATUS_SUCCEED.key,
                this.paymentTransactionStatuses.STATUS_FAILED.key,
              ].includes(childServicePayment._payment_transaction.status)
            ) {
              return false;
            }

            return true;
          }
        );

        if (!retryChildren.includes(true)) {
          break;
        }
      }

      await this.wait(3000);
      this.retryCount += 1;
    }
    this.timer = null;
    this.isPaying = false;
    this.isMounted = true;
  }

  wait(ms) {
    return new Promise((resolve) => {
      this.timer = setTimeout(resolve, ms);
    });
  }

  get clientSecret() {
    return this.activeServicePayment &&
      this.activeServicePayment._payment_intent
      ? this.activeServicePayment._payment_intent.client_secret
      : null;
  }

  async afterPay() {
    await this.init();
    this.$emit('paid');
  }
}
